import { useQuestionCommon } from '@rebuild/materials/shared/question/useQuestionCommon';

export function useQuestionSH601168(options = {}) {
	const { questionTabList, questionTabActValue, queryByTabs: baseQueryByTabs, CODE_FILTER_NAME } =
		useQuestionCommon(options);

	const queryByTabs = async (tabList = []) => {
		await baseQueryByTabs(tabList);

		// 过滤掉无数据的非「全部」Tab（修复 shared 层注释意图未落地的问题）
		const validTabs = questionTabList.value.filter(tab => tab.value !== '' && tab.length > 0);

		if (validTabs.length > 1) {
			// 多个有效 Tab → 头部插入「全部」
			questionTabList.value = [{ label: '全部', value: '', length: 0 }, ...validTabs];
			questionTabActValue.value = '';
		} else if (validTabs.length === 1) {
			// 只有一个有效 Tab → 不展示 Tab 栏，直接用该 sourceBiz 查询
			questionTabList.value = validTabs;
			questionTabActValue.value = validTabs[0].value;
		} else {
			// 全部无数据
			questionTabList.value = [];
			questionTabActValue.value = '';
		}
	};

	return {
		questionTabList,
		questionTabActValue,
		queryByTabs,
		CODE_FILTER_NAME
	};
}
